import LoadableComponent from "../../Loadable"

import {
  ExceptionOutlined,
  LogoutOutlined,
  RadarChartOutlined,
  ToolOutlined,
  DollarOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons"

import { ReactComponent as MasterData } from "@assets/icons/MasterData.svg"
import { ReactComponent as UsersThree } from "@assets/icons/UsersThree.svg"
import { ReactComponent as UsersTwo } from "@assets/icons/UsersTwo.svg"

import { appPermissions } from "@lib/appconst"

export const layouts: any = {
  userLayout: "userLayout",
  portalLayout: "appLayout",
  publicLayout: "publicLayout",
}

export const layoutRouter: any = {
  userLayout: LoadableComponent(() => import("../UserLayout")),
  appLayout: LoadableComponent(() => import("../AppLayout")),
  publicLayout: LoadableComponent(() => import("../PublicLayout")),
}

export const publicLayout: any = {
  termAndCondition: {
    path: "/public/terms-and-conditions",
    title: "TERM_CONDITIONS",
    layout: layouts.userLayout,
    component: LoadableComponent(
      () => import("../../../scenes/public/term-condition")
    ),
  },
  proposalPublic: {
    path: "/public/proposal/:id",
    title: "PROPOSAL",
    layout: layouts.publicLayout,
    component: LoadableComponent(
      () =>
        import("../../../scenes/proposal/public/proposalPublic/proposalPublic")
    ),
  },
}

export const userLayout: any = {
  accountLogin: {
    path: "/account/login",
    title: "Login",
    name: "LOGIN",
    layout: layouts.userLayout,
    component: LoadableComponent(
      () => import("../../../scenes/accounts/Login")
    ),
  },
  forgotPassword: {
    path: "/account/forgot-password",
    title: "FORGOT_PASSWORD",
    name: "FORGOT_PASSWORD",
    layout: layouts.userLayout,
    component: LoadableComponent(
      () => import("../../../scenes/accounts/ForgotPassword")
    ),
  },
  resetPassword: {
    path: "/account/reset-password",
    title: "RESET_PASSWORD",
    name: "RESET_PASSWORD",
    layout: layouts.userLayout,
    component: LoadableComponent(
      () => import("../../../scenes/accounts/ForgotPassword")
    ),
  },
  register: {
    path: "/account/register",
    title: "REGISTER_ACCOUNT",
    name: "REGISTER_ACCOUNT",
    layout: layouts.userLayout,
    component: LoadableComponent(
      () => import("../../../scenes/accounts/Register")
    ),
  },
  registerByOTP: {
    path: "/account/register-by-otp",
    title: "REGISTER_ACCOUNT_BY_OTP",
    name: "REGISTER_ACCOUNT_BY_OTP",
    layout: layouts.userLayout,
    component: LoadableComponent(
      () => import("../../../scenes/accounts/Register/SMSRegisterAccount")
    ),
  },
  registerPhoneForSocial: {
    path: "/account/register-phone-for-social",
    title: "REGISTER_PHONE",
    name: "REGISTER_PHONE",
    layout: layouts.userLayout,
    component: LoadableComponent(
      () => import("../../../scenes/accounts/Register/RegisterPhoneForSocial")
    ),
  },
}

export const portalLayouts: any = {
  todo: {
    path: "/to-do",
    name: "TODO",
    title: "TODO_PAGE_TITLE",
    permission: "",
    layout: layouts.portalLayout,
    icon: CheckSquareOutlined,
    component: LoadableComponent(() => import("../../../scenes/todo")),
  },
  reportDashboard: {
    path: "/dashboard",
    name: "REPORT_DASHBOARD_NEW",
    title: "REPORT_DASHBOARD_NEW",
    layout: layouts.portalLayout,
    permission: appPermissions.reportDashboard.summary,
    icon: DollarOutlined,
    component: LoadableComponent(() => import("../../../scenes/reportDashboard")),
  },
  welcome: {
    path: "/",
    title: "WELCOME_PAGE",
    name: "WELCOME_PAGE",
    layout: layouts.portalLayout,
    component: LoadableComponent(
      () => import("../../../scenes/common/Welcome")
    ),
  },
  accountLogout: {
    path: "/logout",
    permission: "",
    title: "Logout",
    name: "LOGOUT",
    layout: layouts.portalLayout,
    icon: LogoutOutlined,
    component: LoadableComponent(() => import("../../Logout")),
  },
  exception: {
    path: "/exception",
    permission: "",
    title: "exception",
    name: "EXCEPTION",
    layout: layouts.portalLayout,
    icon: ExceptionOutlined,
    component: LoadableComponent(
      () => import("../../../scenes/common/Exception")
    ),
  },
  notification: {
    path: "/user-notification",
    name: "USER_NOTIFICATION",
    permission: "",
    title: "User Notification",
    layout: layouts.portalLayout,
    icon: RadarChartOutlined,
    component: LoadableComponent(
      () => import("../../../scenes/common/Notification")
    ),
  },
  settings: {
    path: "/settings",
    name: "SETTINGS",
    title: "SETTINGS",
    permission: appPermissions.setting.page,
    layout: layouts.portalLayout,
    icon: ToolOutlined,
    component: LoadableComponent(
      () => import("../../../scenes/settingsManagement/index")
    ),
  },
  potentialCustomers: {
    path: "/potential-customers",
    name: "POTENTIAL_CUSTOMERS",
    title: "potentialCustomers",
    permission: appPermissions.customer.page,
    layout: layouts.portalLayout,
    icon: UsersThree,
    component: LoadableComponent(
      () => import("../../../scenes/customerPotential")
    ),
  },
  // opportunity: {
  //   path: "/opportunity",
  //   name: "OPPORTUNITY",
  //   permission: appPermissions.inquiry.page,
  //   title: "opportunity",
  //   layout: layouts.portalLayout,
  //   icon: UsersTwo,
  //   component: LoadableComponent(
  //     () => import("../../../scenes/inquiryManagement")
  //   ),
  // },
  agency: {
    path: "/agency",
    name: "AGENCY_MASTER",
    title: "agency",
    permission: appPermissions.agencyMaster.page,
    layout: layouts.portalLayout,
    icon: UsersTwo,
    component: LoadableComponent(
      () => import("../../../scenes/floorStaff/AgencyPage")
    ),
  },
  staff: {
    path: "/staff",
    name: "TAB_STAFF",
    title: "staff",
    permission: appPermissions.staff.page,
    layout: layouts.portalLayout,
    icon: UsersTwo,
    component: LoadableComponent(
      () => import("../../../scenes/floorStaff/StaffPage")
    ),
  },
  masterData: {
    path: "/master-data",
    name: "MASTER_DATA",
    title: "masterData",
    permission: appPermissions.masterData.page,
    layout: layouts.portalLayout,
    icon: MasterData,
    component: LoadableComponent(
      () => import("../../../scenes/master-data")
    ),
  },
  // administration: {
  //   path: "/system-settings",
  //   name: "SYSTEM_SETTINGS",
  //   title: "systemSettings",
  //   permission: appPermissions.masterData.page,
  //   layout: layouts.portalLayout,
  //   icon: SettingOutlined,
  //   component: LoadableComponent(
  //     () => import("../../../scenes/systemSetting")
  //   ),
  // },
}

export const routers: any = {
  ...userLayout,
  ...portalLayouts,
}

export const appMenuGroups: any = [
  routers.reportDashboard,
  // routers.reportLead,
  // routers.reportInquiry,
  routers.potentialCustomers,
  // routers.opportunity,
  routers.todo,
  routers.agency,
  routers.staff,
  routers.masterData,
  // routers.administration,
  routers.settings,
]
